import { p as proxyCustomElement, H, d as createEvent, h, c as Host } from './p-DTTCzifR.js';
import { B as BaseComponent } from './p-C5lMEBcj.js';

function nextTick(callback) {
    setTimeout(callback, 0);
}

const InputOtp = /*@__PURE__*/ proxyCustomElement(class InputOtp extends H {
    base;
    constructor() {
        super();
        this.__registerHost();
        this.updateModelValue = createEvent(this, "update:modelValue");
        this.change = createEvent(this, "change");
        this.focus = createEvent(this, "focus");
        this.blur = createEvent(this, "blur");
        this.completed = createEvent(this, "completed");
        this.base = new BaseComponent({ tag: 'WANGS-INPUT-OTP', pt: this.pt });
    }
    get cx() {
        return this.base.cx;
    }
    get ptm() {
        return this.base.ptm;
    }
    get el() { return this; }
    focused = false;
    pt;
    modelValue = '';
    length = 4;
    invalid = false;
    disabled = false;
    readonly = false;
    variant = 'outlined';
    mask = false;
    integerOnly = false;
    tokens = [];
    updateModelValue;
    change;
    focus;
    /**
     * Emits when all an input blur and not focusinig any other input
     */
    blur;
    completed;
    handleModelValueChange(newValue) {
        this.tokens = newValue ? newValue.split('') : Array(this.length).fill('');
    }
    onTokensChange(newTokens) {
        if (newTokens.length === this.length && newTokens.every(t => t && t.length === 1)) {
            nextTick(() => this.completed.emit(newTokens.join('')));
        }
    }
    componentWillLoad() {
        this.handleModelValueChange(this.modelValue);
    }
    onInput = (event, index) => {
        const input = event.target;
        const newTokens = this.tokens;
        newTokens[index] = input.value;
        this.tokens = [...newTokens];
        this.updateModel(event);
        if (event.inputType === 'deleteContentBackward') {
            this.moveToPrev(input);
        }
        else if (event.inputType === 'insertText' || event.inputType === 'deleteContentForward') {
            this.moveToNext(input);
        }
    };
    updateModel(event) {
        const newValue = this.tokens.join('');
        this.updateModelValue.emit(newValue);
        this.change.emit({ originalEvent: event, value: newValue });
    }
    moveToPrev(current) {
        const prev = this.findSiblingInput(current, 'previousElementSibling');
        if (prev) {
            prev.focus();
            prev.select();
        }
    }
    moveToNext(current) {
        const next = this.findSiblingInput(current, 'nextElementSibling');
        if (next) {
            next.focus();
            next.select();
        }
    }
    findSiblingInput(element, direction) {
        let sibling = element[direction];
        while (sibling && sibling.tagName !== 'INPUT') {
            sibling = sibling[direction];
        }
        return sibling;
    }
    onFocus = (event) => {
        event.target.select();
        this.focus.emit(event);
        this.focused = true;
    };
    onBlur = (event) => {
        this.focused = false;
        nextTick(() => {
            if (!this.focused) {
                this.blur.emit(event);
            }
        });
    };
    onPaste = (event) => {
        if (this.readonly || this.disabled)
            return;
        const paste = event.clipboardData?.getData('text') ?? '';
        if (!paste)
            return;
        const code = paste.substring(0, this.length);
        if (!this.integerOnly || !isNaN(Number(code))) {
            this.tokens = code.split('');
            this.updateModel(event);
        }
        event.preventDefault();
    };
    onKeyDown = (event) => {
        if (event.ctrlKey || event.metaKey)
            return;
        switch (event.code) {
            case 'ArrowLeft':
                this.moveToPrev(event.target);
                event.preventDefault();
                break;
            case 'ArrowRight':
                this.moveToNext(event.target);
                event.preventDefault();
                break;
            case 'Backspace':
                if (event.target.value === '') {
                    this.moveToPrev(event.target);
                    event.preventDefault();
                }
                break;
            default:
                if (this.integerOnly && !/^\d$/.test(event.key)) {
                    event.preventDefault();
                }
                break;
        }
    };
    isInputFilledIn(i) {
        return !!this.tokens[i];
    }
    getPtmo(i) {
        const { invalid, mask, disabled, integerOnly, modelValue, readonly, length, variant, tokens } = this;
        return {
            props: { invalid, mask, disabled, integerOnly, modelValue, readonly, length, variant },
            state: { tokens },
            parent: this.el.parentElement,
            context: i != null ? { filled: this.isInputFilledIn(i), disabled: this.disabled } : undefined,
        };
    }
    render() {
        return (h(Host, { key: '465f7467e4adc55b59b7bc134347277b4fe3753c', class: this.cx('root', this.getPtmo()) }, Array.from({ length: this.length }).map((_, i) => (h("input", { type: this.mask ? 'password' : 'text', class: this.cx('input', this.getPtmo(i)), value: this.tokens[i] || '', inputmode: this.integerOnly ? 'numeric' : 'text', disabled: this.disabled, readonly: this.readonly, onInput: e => this.onInput(e, i), onFocus: this.onFocus, onBlur: this.onBlur, onPaste: this.onPaste, onKeyDown: this.onKeyDown, maxLength: 1 })))));
    }
    static get watchers() { return {
        "modelValue": ["handleModelValueChange"],
        "tokens": ["onTokensChange"]
    }; }
}, [0, "wangs-input-otp", {
        "pt": [16],
        "modelValue": [1, "model-value"],
        "length": [2],
        "invalid": [4],
        "disabled": [4],
        "readonly": [4],
        "variant": [1],
        "mask": [4],
        "integerOnly": [4, "integer-only"],
        "tokens": [32]
    }, undefined, {
        "modelValue": ["handleModelValueChange"],
        "tokens": ["onTokensChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wangs-input-otp"];
    components.forEach(tagName => { switch (tagName) {
        case "wangs-input-otp":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, InputOtp);
            }
            break;
    } });
}

export { InputOtp as I, defineCustomElement as d };
